import React from 'react';

import { getInnovationTextClasses } from '../../../configs/colors';

function ContactDetailView({ contact, onEdit, onDelete }) {
  const {
    full_name: fullName,
    title,
    position,
    organization,
    email,
    phone_number: phoneNumber,
    address,
    image_url: imageUrl,
    others,
  } = contact;

  const renderField = (label, value) => {
    if (!value) return null;
    return (
      <div className="space-y-1">
        <label className="block text-xs text-gray-400 uppercase tracking-wide">
          {label}
        </label>
        <p className="text-base text-white">{value}</p>
      </div>
    );
  };

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {/* Image Preview */}
        <div className="p-0 flex items-center justify-center overflow-hidden min-h-[220px] md:min-h-0">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Business card"
              className="w-full max-h-[300px] md:max-h-full object-contain rounded-lg shadow"
            />
          ) : (
            <div className="text-gray-400 text-sm">No image</div>
          )}
        </div>

        {/* Contact Details */}
        <div className="space-y-4">
          <div>
            <h2 className={`text-2xl font-semibold ${getInnovationTextClasses()}`}>
              {fullName || 'Unnamed contact'}
            </h2>
          </div>
          
          {renderField('Title', title)}
          {renderField('Position', position)}
          {renderField('Organization', organization)}
          {renderField('Email', email)}
          {renderField('Phone', phoneNumber)}
          {renderField('Address', address)}

          {others && Object.keys(others).length > 0 && (
            <div className="pt-4 mt-4 border-t border-white/10">
              <h3 className="text-sm font-semibold text-gray-200 uppercase tracking-wide mb-3">
                Additional Details
              </h3>
              <div className="space-y-3">
                {Object.entries(others).map(([key, value]) => (
                  <div key={key} className="space-y-1">
                    <label className="block text-xs text-gray-400 uppercase tracking-wide">
                      {key}
                    </label>
                    <p className="text-base text-white whitespace-pre-wrap">
                      {value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-between pt-6 border-t border-white/10">
        <button
          type="button"
          onClick={onDelete}
          className="px-6 py-3 rounded-2xl font-semibold text-white bg-white/10 hover:bg-white/20 transition-colors border border-white/15"
        >
          Delete
        </button>
        <button
          type="button"
          onClick={onEdit}
          className="px-6 py-3 rounded-2xl font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 shadow-lg"
        >
          Edit
        </button>
      </div>
    </div>
  );
}

export default ContactDetailView;

